import { Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Error500 from '../images/500.svg';
import logo from '../images/class-logo-full-color-rgb-313px@72ppi.png';

const StyledHeader = styled.div`
    margin: 10px;
    display: flex;
    align-items: flex-end;
`;

const StyledLogo = styled.img`
    width: 151px;
`;

const StyledTitle = styled(Typography)`
    margin-left: 26px;

    font-family: Lato;
    font-size: 20px;
    font-style: normal;
    font-weight: bold;
    letter-spacing: 0.15000000596046448px;
    text-align: left;
`;

const StyledUserInfoDiv = styled.div`
    margin-left: 10px;
`;

const StyledUserInfoText = styled(Typography)`
    font-family: Lato;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.15000000596046448px;
    text-align: left;
`;

const StyledErrorDiv = styled.div`
    margin: 50px auto 0px auto;
    text-align: center;
`;

const StyledImage = styled.img`
    width: 500px;
`;

const StyledErrorInfoDiv = styled.div`
    margin: 50px auto 0px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const StyledErrorCode = styled(Typography)`
    font-family: Lato;
    font-size: 20px;
    font-style: normal;
    font-weight: bold;
    text-align: left;
`;

const StyledErrorText = styled(Typography)`
    font-family: Lato;
    font-size: 20px;
    font-style: normal;
    width: 100%;
    max-width: 600px;
    margin-bottom: 1rem;
    line-height: 1.5;
`;

const StyledMainDiv = styled.div`
    display: flex;
    flex-direction: column;
`;

const LTIError = () => {
    const { ready, t } = useTranslation('lti-error');
    const search = new URLSearchParams(window.location.search);
    const title = search.get('title');
    const username = search.get('username');
    const errorCode = search.get('status_code') || '';
    const email = search.get('email');
    const role = search.get('role');
    const errorCodesWithSupportLink = ['1001', '1003', '1008', '1010', '1012', '1013', '1014', '1015', '1017', '1018', '500'];
    const showSupportLink = errorCodesWithSupportLink.includes(errorCode);

    const Header = () => (
        <StyledHeader>
            <StyledLogo src={logo}/>
            <StyledTitle>
                {title}
            </StyledTitle>
        </StyledHeader>
    );

    const UserInfo = () => (
        <StyledUserInfoDiv>
            <StyledUserInfoText>
                {username}
            </StyledUserInfoText>
            <StyledUserInfoText>
                {email}
            </StyledUserInfoText>
            <StyledUserInfoText>
                {role}
            </StyledUserInfoText>
        </StyledUserInfoDiv>
    );

    const ErrorInfo = () => (
        <StyledErrorInfoDiv>
            <StyledErrorText>
                {`${t('learning-integration-error')} ${t([`error-${errorCode}`, 'error-generic'])} `}

                {showSupportLink && <Trans i18nKey="lti-error:please-contact-support">
                    {[
                        'Please contact our ',
                        <a href='https://www.class.com/support/class'>
                            support team.
                        </a>
                    ]}
                </Trans>}
            </StyledErrorText>
            <StyledErrorCode>{`${t('error')}: ${errorCode}`}</StyledErrorCode>
            <StyledErrorText>

            </StyledErrorText>
        </StyledErrorInfoDiv>
    );

    if (ready) {
        return (
            <StyledMainDiv>
                <Header/>
                <UserInfo/>
                <StyledErrorDiv>
                    <StyledImage src={Error500}/>
                    <ErrorInfo/>
                </StyledErrorDiv>
            </StyledMainDiv>
        );
    }

    return <></>;
};

export default LTIError;
